import type { SpotForwardSegmentContent } from './type';
import fxTradingSpotForwardData from '../../../data/fxTradingSpotForwardData.json';

export class spotForwadSegmentService {
  async getSpotForwardSegmentData(): Promise<{ data: SpotForwardSegmentContent }> {
    return { data: fxTradingSpotForwardData };
  }
}